"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CheckoutExtra = _interopRequireDefault(require("../components/CheckoutExtra"));
var _styled = require("../components/styled");
var CheckoutExtras = function CheckoutExtras(props) {
  var className = props.className,
    _props$extras = props.extras,
    extras = _props$extras === void 0 ? [] : _props$extras,
    _onChange = props.onChange,
    chosenOptions = props.chosenOptions,
    uncheckOption = props.uncheckOption;
  return /*#__PURE__*/_react["default"].createElement(_styled.Container, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledBodyContainer, null, extras.map(function (extra) {
    return /*#__PURE__*/_react["default"].createElement(_CheckoutExtra["default"], (0, _extends2["default"])({}, extra, {
      uncheckOption: uncheckOption,
      chosenOptions: chosenOptions,
      key: extra.id,
      onChange: function onChange(option) {
        return _onChange(option);
      }
    }));
  })));
};
var StyledBodyContainer = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtras__StyledBodyContainer",
  componentId: "sc-1u3jsxz-0"
})(["background:#fff;padding:16px;"]);
var _default = exports["default"] = CheckoutExtras;